import React from 'react'
import {
  Row,
  message,
  Input,
  Col,
  Button,
  Form,
  Select,
  Table,
  DatePicker,
  Popconfirm,
  Layout,
} from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import { CloseOutlined } from '@ant-design/icons'
import queryString from 'query-string'
import axios from 'axios'
import moment from 'moment'
import { Spin } from 'antd'
import apiRequest from '../../hooks/ApiRequest'
import { getDecodedTokenData } from '../../hooks/DecodeJWT'

const { Option } = Select
const productNameInLocalStorage = localStorage.getItem('productName')

function roundvalue(value) {
  // for round the vlaues john 24 march 2022
  if (value > 0) {
    return parseFloat(value.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0])
  }
}
class EditClientQuotation extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isCorprate: false,
      isTableViible: 'false',
      searchBox: null,
      gotData: false,
      visible: false,
      visibleSearch: false,
      api: 'https://localhost:7279/GetClientDetailsbyid/1',
      access: '',
      a: false,
      riskCover: '',
      riskItem: '',
      coverType: '',
      data: [],
      riskCoverDrop: [],
      riskItemList: [],
      specificProductID: 0,
      selectedInsurer: 0,
      riskVar: '',
      ratePercentage: 0.0,
      rate: 0.0,
      riskcoverfortable: '',
      riskitemfortable: '',
      newProduct: {},
      annualPremiumTotal: 0.0,
      termPremiumTotal: 0.0,
      minimumPremium: 0,
      prorataPremiumTotal: 0.0, //johh 30-03-2022
      tempAddress: '',
      policyStartDate: '',
      policyEndDate: '',
      paymentterm: '', //john 24-03-2022
      policyriskcover: '', //john 24-03-2022
      record: '', //john 24-03-2022
      clientfirstname: '',
      clientsurname: '',
      clientcorporatename: '',
      clientcontactnumber: '',
      clientemailaddress: '',
      clientage: '',
      clientgender: '',
      clientaddress1: '',
      clientaddress2: '',
      nationalid: '',
      customerid: '',
      suburb: '',
      city: '',
      riskItemStartDate: new Date(),
      currentDate: new Date(),
      stampDuty: '',
      reinsuranceLimit: '',
      loading: false,
      cellphone: false,
      currency: '',
      currencyList: [],
      insurerList: [],
      riskCoverIdFromApi: 0,
      currencyFromApi: '',
      corporateType: '',
      sumInsuredTotalFCP: 0,
      monthlyPremiumTotal: 0,
      insurerID: 0,
      ageFcp: '',
      ageRanges: [],
      policyCoverValue: '',
      monthlyPaymentValues: 0,
      addressValue: '',
      DObValue: null,
      relationValue: '',
      sumInsuredValue: 0,
      riskItemValue: 'Select', // Homeinsurance_list_address -id  , rate- 0(number)
      genderValue: '',
      columns: [
        {
          key: 'riskitem',
          title: 'Policy Cover',
          dataIndex: 'policy_cover',
        },
        {
          key: 'riski_tem',
          title: 'Risk Item',
          dataIndex: 'riskitemname',
        },
        {
          key: 'address',
          title: 'Address/Details',
          dataIndex: 'address',
        },
        ...(productNameInLocalStorage === 'LEGAL INSURANCE'
          ? [
            {
              key: 'monthlyPayment',
              title: 'Monthly Payment($)',
              dataIndex: 'monthlypremium',
            },
          ]
          : [
            {
              key: 'suminsured',
              title: 'Sum Insured',
              dataIndex: 'suminsured',
            },
            {
              key: 'rate',
              title: 'Rate(%)',
              dataIndex: 'rate',
            },
            {
              key: 'Proratapremium',
              title: 'Prorata Premium',
              dataIndex: 'prorata',
            },
            {
              key: 'annualpremium',
              title: 'Annual Premium',
              dataIndex: 'annualpremium',
            },
            {
              key: 'termpremium',
              title: 'Term Premium',
              dataIndex: 'termpremium',
            },
          ]),
        {
          key: 'itempstartdate',
          title: 'Start Date',
          dataIndex: 'itempstartdate',
        },
        {
          key: 'actions',
          title: 'Actions',
          render: (_, record, index) =>
            this.state.data.length >= 1 ? (
              <Popconfirm
                title="Do you want to remove this Item?"
                onConfirm={() => this.handleDelete(index)}>
                <button className="delete_btn">
                  <CloseOutlined />
                </button>
              </Popconfirm>
            ) : null,
        },
      ],
      columnsForFCP: [
        {
          key: 'relation',
          title: 'Relationship',
          dataIndex: 'relationship',
          width: '10',
        },
        ...(parseInt(localStorage.getItem('productId')) === 5
          ? [
            {
              key: 'riskitem',
              title: 'Policy Cover',
              dataIndex: 'policy_cover',
            },
            {
              key: 'riski_tem',
              title: 'Risk Item',
              dataIndex: 'riskitemname',
            },
          ]
          : ''),
        {
          key: 'name',
          title: 'Members Name',
          dataIndex: 'membername',
          width: '10',
        },
        {
          key: 'gender',
          title: 'Gender',
          dataIndex: 'gender',
          width: '10',
        },
        {
          key: 'age',
          title: 'Age',
          dataIndex: 'age',
          width: '10',
        },
        ...(parseInt(localStorage.getItem('productId')) === 3
          ? [
            {
              key: 'sumInsured',
              title: 'Sum Insured',
              dataIndex: 'suminsured',
              render: suminsured => {
                return parseFloat(suminsured).toFixed(2)
              },
              width: '10',
            },
            {
              key: 'rate',
              title: 'Premium Rate',
              dataIndex: 'rate',
              render: rate => {
                return parseFloat(rate).toFixed(2)
              },
              width: '10',
            },
            {
              key: 'premiumfactor',
              title: 'Premium Factor',
              dataIndex: 'premiumfactor',
              render: premiumfactor => {
                return parseFloat(premiumfactor).toFixed(2)
              },
              width: '10',
            },
            {
              key: 'monthlypremium',
              title: 'Monthly Pre.',
              dataIndex: 'monthlypremium',
              render: monthlypremium => {
                return parseFloat(monthlypremium).toFixed(2)
              },
              width: '10',
            },
          ]
          : [
            {
              key: 'rate',
              title: 'Pay Out',
              dataIndex: 'rate',
              render: rate => {
                return parseFloat(rate).toFixed(2)
              },
              width: '10',
            },
          ]),
        {
          title: 'Action',
          dataIndex: 'operation',
          render: (_, record, index) =>
            this.state.data.length >= 1 ? (
              <Popconfirm
                title="Do you want to remove this Item?"
                onConfirm={() => this.handleDelete(index)}>
                <button className="delete_btn">
                  <CloseOutlined />
                </button>
              </Popconfirm>
            ) : null,
        },
      ],
      // Variables for fetching user info
      res: [],
      clientName: '',
      quotationId: '',
      startDateFromApi: '',
      endDateFromApi: '',
      riskCoverFromApi: [],
      riskItemFromApi: '',
      clientId: '',
      termPremiumTotalForEdit: 0.0,
      annualPremiumTotalForEdit: 0.0,
      prorataPremiumTotalForEdit: 0.0,
      riskitemid: '',
      dateFormat: 'YYYY-MM-DD',
      productId: parseInt(localStorage.getItem('productId')),
      productName: localStorage.getItem('productName'),
      clientToken: '',
      ClientId: ''
    }
    this.updateInput = this.updateInput.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.ShowHideCorporateName = this.ShowHideCorporateName.bind(this)
    this.setVisible = this.setVisible.bind(this)
    this.setVisibleFalse = this.setVisibleFalse.bind(this)
    this.hideModal = this.hideModal.bind(this)
    this.setVisibleSearch = this.setVisibleSearch.bind(this)
    this.riskitem = this.riskitem.bind(this)
    this.startdateChange = this.startdateChange.bind(this)
    this.enddateChange = this.enddateChange.bind(this)
    // this.handleSubmitWithId = this.handleSubmitWithId(this);
    this.paymenttermChange = this.paymenttermChange.bind(this) //john 24-03-2022
    this.riskcoverChange = this.riskcoverChange.bind(this) //john 24-03-2022
    this.submitpolicy = this.submitpolicy.bind(this)
    this.onInputchange = this.onInputchange.bind(this)
    this.startdateChangeRiskItem = this.startdateChangeRiskItem.bind(this)
    this.state.handleSubmit = this.handleSubmit.bind(this)
    this.currencyChange = this.currencyChange.bind(this)
    this.DobFcp = this.DobFcp.bind(this)
  }
  // delete record from the grid and perform the calculation  john 24-03-2022
  handleDelete = key => {
    this.state.res[0].riskitemlist.splice(key, 1)
    this.state.data = []
    this.state.data.push(this.state.res[0].riskitemlist)
    if (
      this.state.productId === 1 ||
      this.state.productId === 2 ||
      this.state.productId === 4
    ) {
      let annual_premium = 0
      let term_premium = 0
      let pro_rata = 0
      let totalMonthlyPremium = 0

      for (let i = 0; i < this.state.data[0].length; i++) {
        pro_rata = this.state.data[0][i].prorata + pro_rata
        annual_premium = this.state.data[0][i].annualpremium + annual_premium
        term_premium = this.state.data[0][i].termpremium + term_premium
        totalMonthlyPremium =
          this.state.data[0][i].monthlypremium + totalMonthlyPremium
      }
      this.setState({ prorataPremiumTotalForEdit: roundvalue(pro_rata) })
      this.setState({ annualPremiumTotalForEdit: roundvalue(annual_premium) })
      this.setState({ termPremiumTotalForEdit: roundvalue(term_premium) })
      this.setState({
        monthlyPremiumTotal: roundvalue(totalMonthlyPremium),
        monthlyTotalPayment: parseInt(totalMonthlyPremium),
      })
    } else {
      let totalSumInsured = 0
      let totalMonthlyPremium = 0
      for (let i = 0; i < this.state.data[0].length; i++) {
        console.log(this.state.data[0][i])
        totalSumInsured =
          this.state.data[0][i].suminsured > 0
            ? this.state.data[0][i].suminsured
            : 0.0 + totalSumInsured
        totalMonthlyPremium =
          this.state.data[0][i].monthlypremium + totalMonthlyPremium
      }

      this.setState({ sumInsuredTotalFCP: roundvalue(totalSumInsured) })
      this.setState({
        monthlyPremiumTotal: roundvalue(totalMonthlyPremium),
        monthlyTotalPayment: parseInt(totalMonthlyPremium),
      })
      this.setState({
        prorataPremiumTotalForEdit: roundvalue(totalMonthlyPremium),
      })
    }
  }



  setLoading() {
    this.setState({ loading: true })
  }

  setLoadingFalse() {
    this.setState({ loading: false })
  }

  getInsurers = async () => {
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/GetInsurersWithAllowedBrokersByProduct/` +
        this.state.productId,
        'GET',
        null,
        this.state.clientToken,
      )
      if (response.success) {
        this.setState({ insurerList: response.data })
      } else {
        console.error('API Error:', response.error)
      }
    } catch (error) {
      console.error('Request failed:', error)
    }

    await apiRequest(
      `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/GetRiskCoversByInsurerProductId/${this.state.specificProductID}`,
      'GET',
      null,
      this.state.clientToken,
    )
      .then(response => {
        console.log(response)
        if (response.success && response.data) {
          const data = response.data

          this.setState({
            riskCoverDrop: data,
          })
        } else {
          console.error('API Error:', response.error)
        }
      })
      .catch(error => console.error('Error fetching Cover list:', error))
  }

  insurerChange = async value => {
    this.setState({ selectedInsurer: value })
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/GetInsurerProductByInsurerIdProductId?productId=${this.state.productId}&insurerId=${value}`,
        'GET',
      )
      if (response.success) {
        this.setState({ specificProductID: response.data.id })
        this.setState({
          reinsuranceLimit: response?.data.insurerProduct?.maxLimit,
        })
        this.setState({ minimumPremium: response?.data.insurerProduct?.minimumPremium })
      }
      else {
        console.error('API Error:', response.error)
      }
    } catch (error) {
      console.error('Request failed:', error)
    }

    this.getInsurers()
  }

  componentDidMount() {
    this.setState({ loading: true })
    const params = new URLSearchParams(window.location.search);
    const rawToken = params.get('token');
    this.setState({ clientToken: rawToken })
    const TokenData = getDecodedTokenData(rawToken)
    if (this.state.clientId !== null) {
      // not need to chnage
      // 'https://localhost:7246/quotation/GetQuotaionDetailsbyid/2
      apiRequest(
        process.env.REACT_APP_BASE_URL +
        '/quotation/GetQuotaionDetailsbyid/' +
        232,
        // this.state.clientId,
        'GET',
        null,
        rawToken,
      ).then(response => {
        this.setState({ loading: false })
        this.setState({
          clientfirstname: response.data.clientdetail.clientfirstname,
          clientsurname: response.data.clientdetail.clientsurname,
          clientcontactnumber: response.data.clientdetail.clientcontactnumber,
          clientage: response.data.clientdetail.clientage,
          clientaddress1: response.data.clientdetail.clientaddress1,
          clientId: response.data.clientdetail.id,
          nationalid: response.data.clientdetail.nationalid,
          clientcorporatename: response.data.clientdetail.clientcorporatename,
          clientemailaddress: response.data.clientdetail.clientemailaddress,
          clientgender: response.data.clientdetail.clientgender,
          suburb: response.data.clientdetail.suburb,
          city: response.data.clientdetail.city,
          entitytype: response.data.clientdetail.entitytype,
          currency: response.data.pquotationdetail.currency,
          riskCoverFromApi: response.data.pquotationdetail.policyriskcover,
          //riskCoverIdFromApi: response.data.pquotationdetail.riskcoverid,
        })
        this.state.res.push(response.data.pquotationdetail)
        this.setState({ paymentterm: this.state.res[0].paymentterms })
        this.setState({ quotationId: this.state.res[0].quotationnumber })
        // this.setState({ insurerID: this.state.res[0].insurerId })
        this.setState({ selectedInsurer: this.state.res[0].insurerId })
        this.insurerChange(this.state.res[0].insurerId)
        // this.setState({
        //   riskCoverFromApi: parseInt(this.state.res[0].policyriskcover),
        //   // this.state.res[0].policyriskcover.includes(',') == true
        //   //   ? this.state.res[0].policyriskcover.split(',')
        //   // : this.state.res[0].policyriskcover,
        // })
        // this.setState({currencyFromApi:})
        this.setState({ clientName: this.state.res[0].customername })
        this.setState({
          riskItemFromApi: this.state.res[0].riskbuildingmaterial,
        })
        this.setState({
          annualPremiumTotal: this.state.res[0].totalannualpremium,
        })
        this.setState({
          termPremiumTotal: this.state.res[0].totaltermpremium,
        })
        this.setState({ policynumber: this.state.res[0].quotationnumber })
        this.setState({
          policyStartDate: this.state.res[0].policystartdate,
        })
        this.setState({
          policyexpirytdate: this.state.res[0].policyexpirytdate,
        })
        this.setState({ clientId: this.state.res[0].clientid })
        this.setState({
          policyriskcover: this.state.res[0].policyriskcover,
        })
        //  this.setState({startDateFromApi : this.state.res[0].createddate});
        this.setState({ newProduct: this.state.res[0].riskitemlist })
        this.state.data.push(this.state.newProduct)
        if (this.state.newProduct != null) {
          if (this.state.productId === 3 || this.state.productId === 5) {
            for (let i = 0; i < this.state.newProduct.length; i++) {
              console.log(this.state.newProduct[i].suminsured)

              this.setState({
                sumInsuredTotalFCP:
                  this.state.newProduct[i].suminsured +
                  this.state.sumInsuredTotalFCP,
              })
              this.setState({
                monthlyPremiumTotal:
                  this.state.newProduct[i].monthlypremium +
                  this.state.monthlyPremiumTotal,
              })
              this.setState({
                prorataPremiumTotalForEdit:
                  response.data.pquotationdetail.proratatotaltermpremium,
              })
            }
          } else {
            for (let i = 0; i < this.state.newProduct.length; i++) {
              this.setState({
                prorataPremiumTotalForEdit:
                  this.state.newProduct[i].prorata +
                  this.state.prorataPremiumTotalForEdit,
              })
              this.setState({
                annualPremiumTotalForEdit:
                  this.state.newProduct[i].annualpremium +
                  this.state.annualPremiumTotalForEdit,
              })
              this.setState({
                termPremiumTotalForEdit:
                  this.state.newProduct[i].termpremium +
                  this.state.termPremiumTotalForEdit,
              })
            }
          }
        }

        if (
          this.state.res[0].riskitemlist?.length &&
          productNameInLocalStorage === 'LEGAL INSURANCE'
        ) {
          let total = 0
          for (let i = 0; i < this.state.res[0].riskitemlist.length; i++) {
            total =
              parseInt(total) +
              parseInt(this.state.res[0].riskitemlist[i].monthlypremium)
          }
          this.setState({ monthlyTotalPayment: parseInt(total) })
        }

        this.setState({ ClientId: response.data.clientdetail.id })
        console.log('response.data.clientdetail.id', response.data.clientdetail.id);

      })

      apiRequest(
        `${process.env.REACT_APP_BASE_URL_ADMIN}/Product/GetGloabalList/${this.state.productId}`,
        'GET',
        null,
        rawToken,
      )
        .then(response => {
          if (response.success && response.data) {
            const data = response.data.result
            this.setState({
              stampDuty: data.mastersetting[0].stampduty,
              // riskCoverDrop: data.riskcoverlist,
              reinsuranceLimit: data.mastersetting[0].reinsurancelimit,
              currencyList: data.currencylist,
            })
          } else {
            console.error('API Error:', response.error)
          }
        })
        .catch(error => console.error('Error fetching global list:', error))


    }
    console.log('==>', this.state.ClientId);

  }

  currencyChange(value) {
    this.setState({ currency: value })
  }

  hideModal() {
    this.setState({
      visibleSearch: false,
    })
  }



  // Redirecting to another model where client can add customer to the database
  setVisibleSearch() {
    this.setState({
      visibleSearch: false,
    })
    this.setState({ visible: true })
  }

  // Functions for Modal functioanlity to add customers
  setVisible() {
    this.setState({ visible: true })
  }
  setVisibleFalse() {
    this.setState({ visible: false })
  }

  // Function for search functionality
  handleChange({ target }) {
    this.setState({
      [target.name]: target.value,
    })
  }

  ShowHideCorporateName(event) {
    if (event != 'Corporate') {
      this.setState({
        corporate: true,
      })
    } else {
      this.setState({
        isCorprate: false,
      })
    }
  }
  // function for submit add policy 22 march 22 john
  submitpolicy = async e => {
    e.preventDefault()
    let apiurl = ''
    let btnvalue = e.target.value
    this.setState({ loading: true })

    if (btnvalue === 'Finalised') {
      apiurl = process.env.REACT_APP_BASE_URL + '/Policy/Addpolicy'
      try {
        const customerResponse = await apiRequest(
          process.env.REACT_APP_BASE_URL_LOGIN +
          '/api/v1/customer/' +
          this.state.nationalid,
          'GET',
        )
        if (!customerResponse.data) {
          const customerdetail = {
            client_name: this.state.clientfirstname.trim(),
            client_surname: this.state.clientsurname.trim(),
            client_mobile: this.state.clientcontactnumber.trim(),
            client_address: this.state.clientaddress1.trim(),
            client_id_number: this.state.nationalid.trim(),
            client_age: parseInt(this.state.clientage),
            client_entity: this.state.entitytype,
            client_gender: this.state.clientgender,
            client_city: this.state.city,
            client_suburb: this.state.suburb,
            client_email: this.state.clientemailaddress,
            client_coprorate_name: this.state.clientcorporatename,
          }
          await apiRequest(
            process.env.REACT_APP_BASE_URL_CLIENT + '/customer/',
            'POST',
            customerdetail,
          )
        }
      } catch (error) {
        console.error('Error fetching customer data:', error)
      }
    } else {
      // apiurl = process.env.REACT_APP_BASE_URL + '/quotation/Updatequotation/'
      apiurl = 'https://localhost:7279' + '/quotation/Updatequotation/'
    }

    let postData = {
      ...this.state.res[0],
      policyriskcover: this.state.policyriskcover,
      policystartDate: this.state.policyStartDate,
      customeremail: this.state.clientemailaddress,
      policyexpirytdate: this.state.policyexpirytdate,
      paymentterms: this.state.paymentterm,
      grandtotalannualpremium: this.state.annualPremiumTotalForEdit,
      grandtotaltermpremium: this.state.termPremiumTotalForEdit,
      productid: parseInt(this.state.productId),
      productname: this.state.productName,
      nationalid: this.state.nationalid,
      proratatotaltermpremium: this.state.prorataPremiumTotalForEdit,
    }
    const customerdetail = {
      customerName: this.state.clientfirstname.trim(),
      customerSurname: this.state.clientsurname.trim(),
      mobile: this.state.clientcontactnumber.trim(),
      address: this.state.clientaddress1.trim(),
      nationalID: this.state.nationalid.trim(),
      age: this.state.clientage,
      entityType: this.state.entitytype,
      gender: this.state.clientgender,
      city: this.state.city,
      suburb: this.state.suburb,
      emailAddress: this.state.clientemailaddress,
      corporateName: this.state.clientcorporatename,
    }
    if (
      productNameInLocalStorage === 'LEGAL INSURANCE' &&
      (btnvalue === 'Finalised' || btnvalue === 'submit')
    ) {
      let stampDutyForLegalProduct = parseFloat(
        (this.state.monthlyTotalPayment / 100) * this.state.stampDuty,
      )
      let total =
        parseFloat(this.state.monthlyTotalPayment) +
        parseFloat(stampDutyForLegalProduct)
      postData = {
        ...postData,
        grandtotalannualpremium: total.toFixed(2),
        proratatotaltermpremium: this.state.monthlyTotalPayment.toFixed(2),
        stampdutytermpremium: stampDutyForLegalProduct.toFixed(2),
        grandtotaltermpremium: 0,
      }
      delete postData.policystartDate
    }
    try {
      await apiRequest(
        // `${process.env.REACT_APP_BASE_CUST}/Customers/UpdateCustomer/${this.state.customerid}`,
        `${'http://localhost:5008'}/Customers/UpdateCustomer/${this.state.ClientId}`,
        'POST',
        customerdetail,
        this.state.clientToken
      )
    } catch (error) {
      console.error('Error updating customer:', error)
    }
    try {
      const response = await apiRequest(
        apiurl,
        'POST',
        postData,
        this.state.clientToken,
      )
      this.setState({ loading: false })

      if (btnvalue === 'Finalised') {
        message.success('Policy created successfully')
        window.location.href = '/policies'
      } else {
        message.success('Quotation created successfully')
        // window.location.href = '/quotations'
      }
    } catch (error) {
      console.error('Error submitting policy:', error)
      this.setState({ loading: false })
    }
  }
  updateInput() {
    const current = []
    // fetch('https://localhost:7279/GetClientDetailsbyid/1')
    //     .then((response) => response.json())
    //     .then((data) => current.push(data.result));
    // const userRoles = JSON.parse(localStorage.getItem("roles"));
  }

  riskitem(value) {
    // debugger
    this.setState({ cellphone: false })
    this.setState({ riskitemid: value })
    for (let i = 0; i < this.state.riskItemList.length; i++) {
      if (value === this.state.riskItemList[i].riskItemId) {
        this.setState({ rate: this.state.riskItemList[i].ratePercentage })
        this.state.riskitemfortable = this.state.riskItemList[i].riskItemName

        if (this.state.riskItemList[i].riskItemName === 'Cellphone') {
          this.setState({ cellphone: true })
        }
        if (
          this.state.riskItemList[i].riskItemName === 'Jewellery' ||
          this.state.riskItemList[i].riskItemName === 'Art'
        ) {
          this.state.coverType = 'Agreed Value'
        } else {
          this.state.coverType = 'Sum Insured'
        }
      }
    }
    this.setState({ riskItemValue: value })
  }

  handleSubmit = e => {
    e.preventDefault()
    let lastIndex =
      this.state.res[0].riskitemlist !== null &&
        this.state.res[0].riskitemlist.length > 0
        ? this.state.res[0].riskitemlist.length - 1
        : 0
    let lastIndexId =
      this.state.res[0].riskitemlist !== null &&
        this.state.res[0].riskitemlist.length > 0
        ? this.state.res[0].riskitemlist[lastIndex].id
        : 0
    let annual_premium = 0
    let term_premium = 0
    let pro_rata = 0
    this.props.form.validateFields((err, values) => {
      let start_date = this.state.riskItemStartDate
      let end_date = this.state.policyexpirytdate
      var Noofdays = this.findDayDifference(
        new Date(start_date),
        new Date(end_date),
      )
      if (!err) {
        var riskstartdate = new Date(this.state.riskItemStartDate)
        var riskenddate = new Date(this.state.policyexpirytdate)

        this.state.newProduct = {
          id: lastIndexId + 1,
          address: values.address,
          suminsured: values.sumInsured,
          rate: this.state.rate,
          annualpremium: roundvalue(
            (values.sumInsured / 100) * this.state.rate,
          ),
          termpremium: roundvalue(
            ((values.sumInsured / 100) * this.state.rate) / 3,
          ),
          policynumber: this.state.quotationId,
          policy_cover: this.state.policyriskcover,
          policy_cover_id: this.state.riskcoverid,
          riskitemid: this.state.riskitemid.toString(),
          riskitemname: this.state.riskitemfortable,
          policyquotatonid: this.state.res[0].id,
          prorata: roundvalue(
            (values.sumInsured / 100) * this.state.rate * (Noofdays / 365),
          ),
          itempstartdate:
            riskstartdate.getFullYear() +
            '-' +
            (riskstartdate.getMonth() + 1) +
            '-' +
            riskstartdate.getDate(),
          monthlypremium:
            productNameInLocalStorage === 'LEGAL INSURANCE'
              ? this.state.rate
              : 0,
          itempenddate:
            riskenddate.getFullYear() +
            '-' +
            (riskenddate.getMonth() + 1) +
            '-' +
            riskenddate.getDate(),
        }
        if (productNameInLocalStorage === 'LEGAL INSURANCE') {
          let dataForLegal = {
            annualpremium: 0,
            termpremium: 0,
            suminsured: 0,
            prorata: 0,
            itempexpirydate: '',
            membername: '',
            gender: '',
            age: '',
            premiumfactor: 0,
            relationship: '',
            grand_total: 0,
          }
          this.state.newProduct = { ...this.state.newProduct, ...dataForLegal }
        }

        this.state.res[0].riskitemlist.push(this.state.newProduct)

        if (
          this.state.res[0].riskitemlist != null &&
          this.state.res[0].riskitemlist.length > 0
        ) {
          var totalMonthlyPremium = 0
          for (let i = 0; i < this.state.res[0].riskitemlist.length; i++) {
            pro_rata = this.state.res[0].riskitemlist[i].prorata + pro_rata
            annual_premium =
              this.state.res[0].riskitemlist[i].annualpremium + annual_premium
            term_premium =
              this.state.res[0].riskitemlist[i].termpremium + term_premium

            totalMonthlyPremium =
              parseInt(totalMonthlyPremium) +
              parseInt(this.state.res[0].riskitemlist[i].monthlypremium)
          }
        }
      }
      this.setState({
        monthlyTotalPayment: parseInt(totalMonthlyPremium),
      })
      this.state.prorataPremiumTotalForEdit = pro_rata
      this.state.annualPremiumTotalForEdit = annual_premium
      this.state.termPremiumTotalForEdit = term_premium
    })


  }

  handleSubmitForFCP = e => {
    e.preventDefault()
    let lastIndex =
      this.state.res[0].riskitemlist !== null &&
        this.state.res[0].riskitemlist.length > 0
        ? this.state.res[0].riskitemlist.length - 1
        : 0
    let lastIndexId =
      this.state.res[0].riskitemlist !== null &&
        this.state.res[0].riskitemlist.length > 0
        ? this.state.res[0].riskitemlist[lastIndex].id
        : 0
    this.props.form.validateFields((err, values) => {
      if (!err) {
        console.log(values)
        var monthly_pre = 0.0
        var rate = this.state.rate
        if (values.sumInsured > 0) {
          var sum_insured = values.sumInsured / 1000
          monthly_pre =
            parseFloat(sum_insured.toFixed(2)) * parseFloat(rate.toFixed(2))
        } else {
          monthly_pre = rate
        }
        var riskstartdate = new Date(this.state.riskItemStartDate)
        // console.log(
        //   this.state.riskitemid.toString(),
        //   this.state.riskitemfortable,
        // )
        this.state.newProductForFCP = values
        this.state.newProductForFCP = {
          id: lastIndexId + 1,
          riskitemid: this.state.riskitemid.toString(),
          riskitemname: this.state.riskitemfortable,
          rate: this.state.rate,
          gender: values.genderFCP,
          membername: values.name,
          relationship: values.relation,
          suminsured:
            values.sumInsured > 0 ? parseFloat(values.sumInsured) : 0.0,
          premiumfactor: values.sumInsured > 0 ? values.sumInsured / 1000 : 0.0,
          monthlypremium: monthly_pre,
          age: this.state.ageFcp,
          policyquotatonid: 0,
          itempstartdate:
            riskstartdate.getFullYear() +
            '-' +
            (riskstartdate.getMonth() + 1) +
            '-' +
            riskstartdate.getDate(), // this.state.riskItemStartDate,
          policy_cover: this.state.policyriskcover,
          policy_cover_id: this.state.riskcoverid,

          id: 0,
          address: '',
          policynumber: this.state.quotationnumber,
          annualpremium: 0,
          termpremium: 0,
          prorata: 0,
          policyquotatonid: 0,
          itempexpirydate: '',
          grand_total: 0,
        }
      }
    })
    if (productNameInLocalStorage === 'LEGAL INSURANCE') {
      let dataForLegal = {
        annualpremium: 0,
        termpremium: 0,
        suminsured: 0,
        prorata: 0,
        itempexpirydate: '',
        membername: '',
        gender: '',
        age: '',
        premiumfactor: 0,
        relationship: '',
        grand_total: 0,
      }
      this.state.newProductForFCP = {
        ...this.state.newProductForFCP,
        ...dataForLegal,
      }
    }
    //this.state.res[0].riskitemlist.push(this.state.newProductForFCP)
    this.state.data[0].push(this.state.newProductForFCP)
    if (this.state.data[0].length > 0) {
      let sumInsuredTotal = 0
      let monthlyPremiumTotal = 0
      for (let i = 0; i < this.state.data[0].length; i++) {
        sumInsuredTotal = sumInsuredTotal + this.state.data[0][i].suminsured
        monthlyPremiumTotal =
          monthlyPremiumTotal + this.state.data[0][i].monthlypremium
      }
      this.setState({ sumInsuredTotalFCP: roundvalue(sumInsuredTotal) })
      this.setState({ monthlyPremiumTotal: roundvalue(monthlyPremiumTotal) })
      this.setState({
        prorataPremiumTotalForEdit: roundvalue(monthlyPremiumTotal),
      })
    }

  }

  findDayDifference(date1, date2) {
    // always round down
    return Math.floor(Math.abs(date2 - date1) / (1000 * 60 * 60 * 24))
  }
  startdateChangeRiskItem(date, datestring) {
    if (datestring === '') {
      message.warning('Risk item start date cannot be null')
    } else {
      if (new Date(this.state.policyexpirytdate) < new Date(datestring)) {
        message.error('Invalid Date')
      } else {
        this.setState({ riskItemStartDate: datestring })
      }
    }
  }

  startdateChange(date, datestring) {
    if (datestring === '') {
      message.warning('Start date cannot be empty')
    } else if (new Date(datestring) >= new Date(this.state.currentDate)) {
      this.setState({ policyStartDate: new Date(datestring) })
      var year = new Date(datestring).getFullYear()
      var month = new Date(datestring).getMonth()
      var day = new Date(datestring).getDate()
      var Newdate = new Date(year + 1, month, day)
      this.setState({ policyexpirytdate: Newdate })
    } else {
      message.warning('Start date cannot be smaller than Current Date')
    }
  }

  enddateChange(date, datestring) {
    if (datestring === '') {
      message.warning('End date cannot be empty.')
    } else {
      if (new Date(this.state.policyStartDate) < new Date(datestring)) {
        this.setState({ policyexpirytdate: new Date(datestring) })
      } else {
        message.error('Invalid Duration ')
      }
    }
  }

  DobFcp(date, datestring) {
    this.setState({ DObValue: datestring })

    if (this.state.policyriskcover.length > 0) {
      var a = moment(new Date())
      var b = moment(date)
      var daysOld = a.diff(b, 'days')
      var monthsOld = a.diff(b, 'months')
      var yearsOld = a.diff(b, 'years') // 1

      var agesuffix =
        yearsOld === 1
          ? 'year'
          : yearsOld > 1
            ? 'years'
            : monthsOld === 1
              ? 'month'
              : monthsOld > 1
                ? 'months'
                : daysOld === 1
                  ? 'day'
                  : 'days'
      if (yearsOld > 0) {
        this.setState({ ageFcp: yearsOld.toString() + ' ' + agesuffix })
      } else if (monthsOld > 0) {
        this.setState({ ageFcp: monthsOld.toString() + ' ' + agesuffix })
      } else {
        this.setState({ ageFcp: daysOld.toString() + ' ' + agesuffix })
      }
      for (let i = 0; i < this.state.riskItemList.length; i++) {
        var rname = this.state.riskItemList[i].riskitemname
        var range = rname.replace(/[^\d.]/g, '')
        var Range1 = 0
        var Range2 = 0
        if (range.length > 3) {
          Range1 = parseInt(range.substring(0, 2))
          Range2 = parseInt(range.slice(-2))
        } else if (range.length === 3) {
          Range1 = parseInt(range.substring(0, 1))
          Range2 = parseInt(range.slice(-2))
          if (yearsOld === 0) {
            this.setState({ rate: this.state.riskItemList[i].ratepercentage })
          }
        }
        if (yearsOld > 0 && range.length > 3) {
          if (yearsOld <= Range2 && yearsOld >= Range1) {
            this.setState({ rate: this.state.riskItemList[i].ratepercentage })
          } else if (yearsOld > 80) {
            this.setState({ rate: [] })
          }
        }
      }
    } else {
      datestring = null
      message.warning('Please select Policy Cover')
    }
  }

  getRiskCoverName = val => {
    const { riskCoverDrop } = this.state
    const cover = riskCoverDrop.find(item => item.riskCoverId === Number(val))
    return cover ? cover.riskCoverName : null
  }
  onInputchange = e => {
    console.log(e);

    const { name, value } = e.target
    console.log(name, value)

    this.setState({ [name]: value })
  }

  //function to get riskcover multiple selection
  async riskcoverChange(value) {
    this.setState({ policyriskcover: value.toString() })

    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/GetRiskItemsByCoverId/${value}`,
        'GET', null, this.state.clientToken)
      // debugger

      if (response.success == false) {
        this.setState({
          riskItemList: [],
        })
      }
      if (response.success && response.data.length > 0) {
        const res_data = response.data
        if (this.state.productId === 3) {
          let range = []
          let range2 = []
          let j = 0

          res_data.forEach((item, i) => {
            range[i] = item.riskitemname.replace(/[^\d.-]/g, '')
          })

          range.forEach(r => {
            if (r !== '1-23') {
              range2[j++] = parseInt(r.substring(0, 2))
              range2[j++] = parseInt(r.substring(3, 5))
            }
          })

          range2.sort((a, b) => a - b)

          this.setState({ ageRanges: range2 })
        }

        const selectedCoverName = this.getRiskCoverName(value)
        // console.log(selectedCoverName);

        this.setState({
          riskItemList: res_data,
          policyriskcover: selectedCoverName,
          riskcoverid: value,
        })
      }
    } catch (error) {
      console.error('Error fetching risk cover:', error)
    }

    this.setState({ policyCoverValue: value })
  }

  paymenttermChange(value) {
    //  select paymentterm john
    var monthsToBeAdded = parseInt(value)
    this.setState({ paymentterm: value })
    var year = new Date(this.state.policyStartDate).getFullYear()
    var month =
      new Date(this.state.policyStartDate).getMonth() + monthsToBeAdded
    var day = new Date(this.state.policyStartDate).getDate()
    var Newdate = new Date(year, month, day)
    this.setState({ paymentterm: value })
    this.setState({ policyexpirytdate: Newdate })
  }

  componentWillUnmount() {
    localStorage.removeItem('clientId')
  }

  render() {
    const { getFieldDecorator } = this.props.form

    let riskCoverList =
      this.state.riskCoverDrop.length > 0 &&
      this.state.riskCoverDrop.map((item, i) => {
        return (
          <option key={i} value={item.riskCoverId}>
            {item.riskCoverName}
          </option>
        )
      }, this)
    let paymenttermList = Array.from({ length: 12 }, (_, i) => i + 1).map(
      (item, i) => {
        return (
          //<Select.Option   key={i} value={item.riskcoverid}>{item.riskname}</Select.Option>
          <Select.Option key={i} value={item.toString()}>
            {item}
          </Select.Option>
        )
      },
      this,
    )
    let riskNameList =
      this.state.riskItemList.length > 0 &&
      this.state.riskItemList.map((item, i) => {
        return (
          <Select.Option key={i} value={item.riskItemId}>
            {item.riskItemName}
          </Select.Option>
        )
      }, this)

    // console.log('risk name list', this.state.riskItemList)

    let currencyList =
      this.state.currencyList.length > 0 &&
      this.state.currencyList.map((item, i) => {
        return (
          <Select.Option key={i} value={item.currencycode}>
            {item.currencyname + '-' + item.currencycode}
          </Select.Option>
        )
      }, this)
    let InsuranceList =
      this.state.insurerList.length > 0 &&
      this.state.insurerList.map((item, i) => {
        return (
          <Select.Option key={item.id} value={item.id}>
            {`${item.firstName} ${item.lastName}`}
          </Select.Option>
        )
      }, this)

    return (
      <div className="body-height">
        <div className="bg-white">
          <Spin
            className="loader-icon-fixed"
            spinning={this.state.loading}
            size="large"></Spin>
          <div className=" dash-bg-white">
            <Row>
              <Col xs={24} sm={24} md={12} lg={12}>
                <div className="flex justify-between">
                  <h5
                    style={{
                      color: '#F15A2B',
                      fontWeight: '500',
                      fontSize: '20px',
                      marginBottom: '0',
                    }}>
                    <b>
                      Edit Quotation{' '}
                      {/* <label
                      style={{
                        color: '#F15A2B',
                        fontWeight: '700',
                        fontSize: '20px',
                      }}>
                        {this.state.productName}
                    </label> */}
                    </b>
                  </h5>
                </div>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12}>
                <div className="right-text align-left">
                  {this.state.clientId !== null && (
                    <label>
                      <b>Quotation Number : {this.state.quotationId}</b>
                    </label>
                  )}
                </div>
              </Col>
            </Row>
          </div>
          <div className=" dash-bg-white">
            <div className="d-inline-block">
              <Row gutter={[16, 24]}>
                <Col xs={12} sm={24} md={12} lg={12}>
                  <h3
                    style={{
                      color: '#F15A2B',
                      fontWeight: '700',
                      fontSize: '20px',
                      margin: '0',
                    }}>
                    Basic Customer Details
                  </h3>
                </Col>
                {/* <Col xs={12} sm={24} md={12} lg={12}>
                    <div className="align-right">
                      <Button
                        size="default"
                        value={'Finalised'}
                        onClick={this.submitpolicy}
                        style={{
                          marginLeft: 'auto',
                          color: '#fd7e14',
                          borderColor: '#fd7e14',
                        }}>
                        Finalise
                      </Button>
                    </div>
                  </Col> */}
              </Row>
            </div>

            <Row gutter={[16, 16]}>
              <Col xs={24} md={12} lg={4}>
                <Form.Item label="Entity Type" name="entitytype">
                  <Input
                    disabled
                    value={this.state.entitytype}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>

              {this.state.clientfirstname && (
                <Col xs={24} md={12} lg={4}>
                  <Form.Item label="First Name" name="clientfirstname">
                    <Input
                      // disabled
                      placeholder="Enter Firstname"
                      onChange={this.onInputchange}
                      name="clientfirstname"
                      value={
                        this.state.clientfirstname.includes('undefined')
                          ? this.state.clientfirstname.slice(9)
                          : this.state.clientfirstname
                      }
                    />
                  </Form.Item>
                </Col>
              )}

              {this.state.clientsurname && (
                <Col xs={24} md={12} lg={4}>
                  <Form.Item label="Sur Name" name="clientsurname">
                    <Input
                      placeholder="Enter surname"
                      name="clientsurname"
                      onChange={this.onInputchange}
                      value={this.state.clientsurname}
                    />
                  </Form.Item>
                </Col>
              )}

              {this.state.clientcorporatename && (
                <Col xs={24} md={12} lg={4}>
                  <Form.Item label="Corporate Name" name="clientcorporatename">
                    <Input
                      placeholder="Corporate name"
                      name="clientcorporatename"
                      onChange={this.onInputchange}
                      value={this.state.clientcorporatename}
                    />
                  </Form.Item>
                </Col>
              )}

              <Col xs={24} md={12} lg={4}>
                <Form.Item label="Contact Number" name="clientcontactnumber">
                  <Input
                    placeholder="eg:987654321"
                    name="clientcontactnumber"
                    onChange={this.onInputchange}
                    value={this.state.clientcontactnumber}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} md={12} lg={4}>
                <Form.Item label="Email Address" name="clientemailaddress">
                  <Input
                    placeholder="abc@gmail.com"
                    name="clientemailaddress"
                    onChange={this.onInputchange}
                    value={this.state.clientemailaddress}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} lg={4}>
                <Form.Item label="Age" name="clientage">
                  <Input
                    placeholder="eg:24"
                    name="clientage"
                    onChange={this.onInputchange}
                    value={this.state.clientage}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} md={12} lg={4}>
                <Form.Item label="National Id" name="nationalid">
                  <Input
                    disabled
                    placeholder="National Id"
                    value={this.state.nationalid}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} md={12} lg={8}>
                <Form.Item label="Address" name="clientaddress1">
                  <TextArea
                    placeholder="Enter Address"
                    name="clientaddress1"
                    onChange={this.onInputchange}
                    value={this.state.clientaddress1}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} md={12} lg={4}>
                <Form.Item label="Suburb" name="suburb">
                  <Input
                    placeholder="Enter Suburb"
                    name="suburb"
                    onChange={this.onInputchange}
                    value={this.state.suburb}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} md={12} lg={4}>
                <Form.Item label="City" name="city">
                  <Input
                    placeholder="Enter City"
                    name="city"
                    onChange={this.onInputchange}
                    value={this.state.city}
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>
          <div className=" dash-bg-white">
            <h3
              style={{
                color: '#F15A2B',
                fontWeight: '700',
                fontSize: '20px',
                margin: '0',
                marginBottom: '20px',
              }}>
              Policy Details
            </h3>
            <Row gutter={[16, 16]}>
              <Col xs={24} md={12} lg={5}>
                <Form.Item label="Insurer List">
                  <Select
                    defaultValue="--Select option--"
                    onChange={this.insurerChange}
                    value={this.state.selectedInsurer || undefined}
                    disabled
                    style={{ display: 'inline' }}>
                    {InsuranceList}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={12} lg={5}>
                <Form.Item label="Policy Start Date">
                  <DatePicker
                    value={moment(
                      this.state.policyStartDate,
                      this.state.dateFormat,
                    )}
                    disabled
                    style={{ width: '100%' }}
                    placeholder="Policy Start Date"
                    onChange={this.startdateChange}
                  />
                </Form.Item>
              </Col>

              {this.state.productId === 1 ||
                this.state.productId === 2 ||
                this.state.productId === 4 ? (
                <Col xs={24} md={12} lg={5}>
                  <Form.Item label="Payment Term">
                    <Select
                      disabled
                      value={this.state.paymentterm}
                      onChange={this.paymenttermChange}
                      defaultValue="Payment Term"
                      style={{ display: 'inline' }}>
                      {paymenttermList}
                    </Select>
                  </Form.Item>
                </Col>
              ) : (
                ''
              )}

              {(this.state.productId === 1 ||
                this.state.productId === 2 ||
                this.state.productId === 4) &&
                productNameInLocalStorage !== 'LEGAL INSURANCE' ? (
                <Col xs={24} md={12} lg={5}>
                  <Form.Item label="Policy End Date">
                    <DatePicker
                      value={moment(
                        this.state.policyexpirytdate,
                        this.state.dateFormat,
                      )}
                      disabled
                      style={{ width: '100%' }}
                      placeholder="Policy End Date"
                      onChange={this.enddateChange}
                    />
                  </Form.Item>
                </Col>
              ) : (
                ''
              )}
              <Col xs={24} md={12} lg={4}>
                <Form.Item label="Currency">
                  <Select
                    disabled
                    placeholder="Select option"
                    value={this.state.currency}
                    onChange={this.currencyChange}
                    style={{ display: 'inline' }}>
                    {currencyList}
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} md={12} lg={5}>
                <Form.Item label="Insurance Limit">
                  <Input value={this.state.reinsuranceLimit} disabled />
                </Form.Item>
              </Col>
            </Row>
          </div>
          <div className="dash-bg-white">
            <h3
              style={{
                color: '#F15A2B',
                fontWeight: '700',
                fontSize: '20px',
                margin: '0',
                marginBottom: '20px',
              }}>
              Product Details
            </h3>
            <Form
              onSubmit={
                this.state.productId === 3 || this.state.productId === 5
                  ? this.handleSubmitForFCP
                  : this.handleSubmit
              }
              id="my-form">
              <Row gutter={[16, 24]}>
                <Col xs={24} md={12} lg={4}>
                  <Form.Item label="Policy Cover">
                    {getFieldDecorator('riskcover', {
                      rules: [
                        {
                          required: false,
                        },
                      ],
                    })(
                      <select
                        className="select-input"
                        placeholder="Select option"
                        value={this.state.policyCoverValue}
                        id="policy_Cover"
                        // setfieldsvalue={this.state.riskCoverFromApi}

                        onChange={e => this.riskcoverChange(e.target.value)}
                        style={{ display: 'inline' }}>
                        <option value="">---Select--</option>
                        {riskCoverList}
                      </select>,
                    )}
                  </Form.Item>
                </Col>
                {this.state.productId !== 3 ? (
                  <Col xs={24} md={12} lg={4}>
                    <Form.Item
                      label={
                        this.state.productId === 3 ? 'Age Range:' : 'Risk Item:'
                      }>
                      <Select
                        defaultValue={
                          this.state.productId === 3 ? 'Age Range' : 'Risk Item'
                        }
                        onChange={this.riskitem}
                        value={this.state.riskItemValue}
                        style={{ display: 'inline' }}>
                        {riskNameList}
                      </Select>
                    </Form.Item>
                  </Col>
                ) : (
                  ''
                )}

                {this.state.productId === 3 || this.state.productId === 5 ? (
                  <Col xs={24} md={12} lg={4}>
                    <Form.Item label="Date of Birth">
                      <DatePicker
                        disabledDate={current =>
                          current.isAfter(moment().subtract(1, 'day')) ||
                          current.isBefore(moment().subtract(64, 'years'))
                        }
                        onChange={this.DobFcp}
                        style={{ width: '100%' }}
                        value={
                          this.state.DObValue != null
                            ? moment(this.state.DObValue, this.state.dateFormat)
                            : null
                        }
                      />
                    </Form.Item>
                  </Col>
                ) : (
                  ''
                )}

                {this.state.productId === 3 || this.state.productId === 5 ? (
                  <Col xs={24} md={12} lg={4}>
                    <Form.Item label="Age">
                      <Input
                        placeholder="eg:24"
                        value={this.state.ageFcp}
                      />
                    </Form.Item>
                  </Col>
                ) : (
                  ''
                )}

                {this.state.productId === 3 || this.state.productId === 5 ? (
                  <Col xs={24} md={12} lg={4}>
                    <Form.Item label="Relationship">
                      {getFieldDecorator('relation', {
                        initialValue: '',
                        rules: [
                          {
                            required: this.state.isRequired,

                            message: 'Please input Relationship!',
                          },
                        ],
                      })(
                        <select
                          className="select-input"
                          id="relationshipValue"
                          value={this.state.relationValue}>
                          <option value="">---Select--</option>
                          <option value="Principal Member">
                            Principal Member
                          </option>
                          <option value="Spouse">Spouse</option>
                          <option value="Child">Child</option>
                          <option value="Grand Parent">Grand Parent</option>
                          <option value="Other">Other</option>
                        </select>,
                      )}
                    </Form.Item>
                  </Col>
                ) : (
                  ''
                )}

                {this.state.productId === 3 || this.state.productId === 5 ? (
                  <Col xs={24} md={12} lg={4}>
                    <Form.Item label="Name">
                      {getFieldDecorator('name', {
                        initialValue: '',
                        rules: [
                          {
                            required: this.state.isRequired,

                            message: 'Please input Name!',
                          },
                        ],
                      })(<Input placeholder="Name" />)}
                    </Form.Item>
                  </Col>
                ) : (
                  ''
                )}

                {this.state.productId === 3 || this.state.productId === 5 ? (
                  <Col xs={24} md={12} lg={4}>
                    <Form.Item label="Gender">
                      {getFieldDecorator('genderFCP', {
                        initialValue: '',
                        rules: [
                          {
                            required: this.state.isRequired,

                            message: 'Please input gender!',
                          },
                        ],
                      })(
                        <select
                          className="select-input"
                          value={this.state.genderValue}>
                          <option value="">---Select--</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                        </select>,
                      )}
                    </Form.Item>
                  </Col>
                ) : (
                  ''
                )}

                {(this.state.cellphone === false &&
                  this.state.productId === 1) ||
                  (this.state.cellphone === false &&
                    this.state.productId === 2) ||
                  (this.state.cellphone === false &&
                    this.state.productId === 4) ? (
                  <Col xs={24} md={12} lg={4}>
                    <Form.Item label="Address/Item Details">
                      {getFieldDecorator('address', {
                        rules: [
                          {
                            required: true,
                            message: 'Please input Address!',
                            whitespace: false,
                          },
                        ],
                      })(<Input placeholder="Address/Item Details" />)}
                    </Form.Item>
                  </Col>
                ) : (
                  ''
                )}

                <Col xs={24} md={12} lg={4} style={{ display: 'none' }}>
                  <Form.Item label="Cover type">
                    <Input
                      placeholder="Cover Type"
                      value={this.state.coverType}
                    />
                  </Form.Item>
                </Col>
                {this.state.cellphone === false &&
                  this.state.productId !== 5 &&
                  productNameInLocalStorage !== 'LEGAL INSURANCE' ? (
                  <Col xs={24} md={12} lg={3}>
                    <Form.Item label="Sum Insured">


                      {getFieldDecorator('sumInsured', {
                        rules: [
                          {
                            required: true,
                            message: 'Please input Amount!',
                            whitespace: false,
                          },
                          {
                            validator: (_, value, callback) => {
                              if (!value) {
                                callback();
                                return;
                              }

                              const { minimumPremium, currency, currencyRates } = this.state;
                              const numericValue = Number(value);

                              if (isNaN(numericValue)) {
                                callback('Amount must be a number!');
                                return;
                              }

                              // Get selected currency code (from state or form)
                              const selectedCurrency = currency || this.props.form.getFieldValue('currency');
                              // Get conversion rates
                              const fromRate = currencyRates && currencyRates[selectedCurrency] ? currencyRates[selectedCurrency].conversionRate : 1;
                              const toRate = currencyRates && currencyRates['USD'] ? currencyRates['USD'].conversionRate : 1;

                              if (!fromRate || !toRate) {
                                callback('Currency conversion rate not available');
                                return;
                              }

                              // Convert entered value to USD
                              const amountInUSD = (numericValue / fromRate) * toRate;

                              if (amountInUSD < minimumPremium) {
                                callback(`Amount must be greater than or equal to ${minimumPremium} USD`);
                              } else {
                                callback();
                              }
                            },
                          },
                        ],
                      })(
                        <Input
                          value={this.state.sumInsuredValue}
                          placeholder="Amount"
                        />,
                      )}
                    </Form.Item>
                  </Col>
                ) : (
                  ''
                )}

                {productNameInLocalStorage === 'LEGAL INSURANCE' ? (
                  <Col xs={24} md={12} lg={2}>
                    <Form.Item label={'Monthly Payment'}>
                      <Input
                        placeholder={'Monthly Payment'}
                        disabled
                        value={parseFloat(this.state.rate).toFixed(2)}
                      />
                    </Form.Item>
                  </Col>
                ) : (
                  <Col xs={24} md={12} lg={2}>
                    <Form.Item
                      label={
                        this.state.productId === 3
                          ? 'Rate'
                          : this.state.productId === 5
                            ? 'Pay-out'
                            : 'Rate(%)'
                      }>
                      <Input
                        placeholder={
                          this.state.productId === 3
                            ? 'Rate'
                            : this.state.productId === 5
                              ? 'Pay-out'
                              : 'Rate(%)'
                        }
                        disabled
                        value={parseFloat(this.state.rate).toFixed(2)}
                      />
                    </Form.Item>
                  </Col>
                )}

                <Col xs={24} md={12} lg={4}>
                  <Form.Item label="Start Date">
                    <DatePicker
                      style={{ width: '100%' }}
                      placeholder="Risk item  start date"
                      value={moment(
                        this.state.riskItemStartDate,
                        this.state.dateFormat,
                      )}
                      onChange={this.startdateChangeRiskItem}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={3}>
                  <div className="add-button">
                    <Button
                      htmlType="submit"
                      size="default"
                      className="add-secondary">
                      Add
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          </div>
          <div className="dash-bg-white no-padding">
            <div
              className={
                this.state.productId !== 3
                  ? 'table-grid-bx width-11'
                  : 'table-grid-bx width-11 col-th-10'
              }>
              <Table
                rowKey={record => record.id}
                className="table-scroll-auto"
                columns={
                  this.state.productId === 3 || this.state.productId === 5
                    ? this.state.columnsForFCP
                    : this.state.columns
                }
                dataSource={this.state.data[0]}
                pagination={false}
              />
              <div className="grand-total-bx" style={{ textAlign: 'left' }}>
                {this.state.productId === 5 && (
                  <table width="100%">
                    <tbody>
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td style={{ textAlign: 'left' }}>
                          <b>Total</b>
                          <br></br>
                        </td>
                        {this.state.clientId === null && (
                          <>
                            <td style={{ textAlign: 'left' }}>
                              {parseFloat(
                                this.state.annualPremiumTotal,
                              ).toFixed(2)}
                            </td>
                            <td style={{ textAlign: 'left' }}>
                              {parseFloat(this.state.termPremiumTotal).toFixed(
                                2,
                              )}
                            </td>
                          </>
                        )}
                        {this.state.clientId !== null && (
                          <>
                            <td style={{ textAlign: 'left' }}>
                              {parseFloat(
                                this.state.prorataPremiumTotalForEdit,
                              ).toFixed(2)}
                            </td>
                          </>
                        )}
                        <td></td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td style={{ textAlign: 'left' }}>
                          <b>Stamp Duty</b>
                        </td>
                        <td style={{ textAlign: 'left' }}>
                          {parseFloat(
                            (this.state.prorataPremiumTotalForEdit / 100) *
                            this.state.stampDuty,
                          ).toFixed(2)}
                        </td>
                        <td></td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td style={{ textAlign: 'left' }}>
                          <b>Grand Total</b>
                        </td>
                        {this.state.clientId === null && (
                          <>
                            <td style={{ textAlign: 'left' }}>
                              {parseFloat(
                                (this.state.annualPremiumTotal / 100) *
                                this.state.stampDuty +
                                this.state.annualPremiumTotal,
                              ).toFixed(2)}
                            </td>
                            <td style={{ textAlign: 'left' }}>
                              {parseFloat(
                                (this.state.termPremiumTotal / 100) *
                                this.state.stampDuty +
                                this.state.termPremiumTotal,
                              ).toFixed(2)}
                            </td>
                          </>
                        )}
                        {this.state.clientId !== null && (
                          <>
                            <td style={{ textAlign: 'left' }}>
                              {parseFloat(
                                (this.state.prorataPremiumTotalForEdit / 100) *
                                this.state.stampDuty +
                                this.state.prorataPremiumTotalForEdit,
                              ).toFixed(2)}
                            </td>
                          </>
                        )}
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                )}
                {this.state.productId === 3 && (
                  <table width="100%">
                    <tbody>
                      <tr>
                        <td style={{ width: '100px', minWidth: '100px' }}></td>
                        <td style={{ width: '100px', minWidth: '15px' }}></td>
                        <td style={{ width: '100px', minWidth: '15px' }}></td>
                        <td
                          className="grandTotal"
                          style={{
                            textAlign: 'left',
                            width: '15px',
                            minWidth: '15px',
                            padding: '10px 10px 10px 0 !important',
                          }}>
                          <b>Grand Total</b>
                          <br></br>
                        </td>
                        <td
                          className="grandTotal-no-padding"
                          style={{
                            textAlign: 'left',
                            width: '15px',
                            minWidth: '15px',
                            paddingLeft: ' 40px !important',
                          }}>
                          {parseFloat(this.state.sumInsuredTotalFCP).toFixed(2)}
                        </td>
                        <td style={{ width: '15px', minWidth: '15px' }}> </td>
                        <td style={{ width: '15px', minWidth: '15px' }}></td>
                        <td
                          style={{
                            textAlign: 'left',
                            width: '15px',
                            minWidth: '15px',
                            padding: '10px 16px',
                            paddingLeft: ' 24px !important',
                          }}>
                          {parseFloat(this.state.monthlyPremiumTotal).toFixed(
                            2,
                          )}
                        </td>
                        <td style={{ width: '15px', minWidth: '15px' }}></td>
                      </tr>
                    </tbody>
                  </table>
                )}
                {this.state.productId === 1 || this.state.productId === 2 ? (
                  <table width="100%">
                    <tbody>
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>

                        <td style={{ textAlign: 'left' }}>
                          <b>Total</b>
                          <br></br>
                        </td>
                        {this.state.clientId === null && (
                          <>
                            <td style={{ textAlign: 'left' }}>
                              {parseFloat(
                                this.state.annualPremiumTotal,
                              ).toFixed(2)}
                            </td>
                            <td style={{ textAlign: 'left' }}>
                              {parseFloat(this.state.termPremiumTotal).toFixed(
                                2,
                              )}
                            </td>
                          </>
                        )}
                        {this.state.clientId !== null && (
                          <>
                            <td style={{ textAlign: 'left' }}>
                              {parseFloat(
                                this.state.prorataPremiumTotalForEdit,
                              ).toFixed(2)}
                            </td>
                            <td style={{ textAlign: 'left' }}>
                              {parseFloat(
                                this.state.annualPremiumTotalForEdit,
                              ).toFixed(2)}
                            </td>
                            <td style={{ textAlign: 'left' }}>
                              {parseFloat(
                                this.state.termPremiumTotalForEdit,
                              ).toFixed(2)}
                            </td>
                          </>
                        )}

                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>

                        <td style={{ textAlign: 'left' }}>
                          <b>Stamp Duty</b>
                        </td>
                        <td style={{ textAlign: 'left' }}>
                          {parseFloat(
                            (this.state.prorataPremiumTotalForEdit / 100) *
                            this.state.stampDuty,
                          ).toFixed(2)}
                        </td>
                        <td style={{ textAlign: 'left' }}>
                          {parseFloat(
                            (this.state.annualPremiumTotalForEdit / 100) *
                            this.state.stampDuty,
                          ).toFixed(2)}
                        </td>
                        <td style={{ textAlign: 'left' }}>
                          {parseFloat(
                            (this.state.termPremiumTotalForEdit / 100) *
                            this.state.stampDuty,
                          ).toFixed(2)}
                        </td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td style={{ textAlign: 'left' }}>
                          <b>Grand Total</b>
                        </td>
                        {this.state.clientId === null && (
                          <>
                            <td style={{ textAlign: 'left' }}>
                              {parseFloat(
                                (this.state.prorataPremiumTotal / 100) *
                                this.state.stampDuty +
                                this.state.prorataPremiumTotal,
                              ).toFixed(2)}
                            </td>
                            <td style={{ textAlign: 'left' }}>
                              {parseFloat(
                                (this.state.annualPremiumTotal / 100) *
                                this.state.stampDuty +
                                this.state.annualPremiumTotal,
                              ).toFixed(2)}
                            </td>
                            <td style={{ textAlign: 'left' }}>
                              {parseFloat(
                                (this.state.termPremiumTotal / 100) *
                                this.state.stampDuty +
                                this.state.termPremiumTotal,
                              ).toFixed(2)}
                            </td>
                          </>
                        )}
                        {this.state.clientId !== null && (
                          <>
                            <td style={{ textAlign: 'left' }}>
                              {parseFloat(
                                (this.state.prorataPremiumTotalForEdit / 100) *
                                this.state.stampDuty +
                                this.state.prorataPremiumTotalForEdit,
                              ).toFixed(2)}
                            </td>
                            <td style={{ textAlign: 'left' }}>
                              {parseFloat(
                                (this.state.annualPremiumTotalForEdit / 100) *
                                this.state.stampDuty +
                                this.state.annualPremiumTotalForEdit,
                              ).toFixed(2)}
                            </td>
                            <td style={{ textAlign: 'left' }}>
                              {parseFloat(
                                (this.state.termPremiumTotalForEdit / 100) *
                                this.state.stampDuty +
                                this.state.termPremiumTotalForEdit,
                              ).toFixed(2)}
                            </td>
                          </>
                        )}

                        <td></td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                ) : (
                  ''
                )}

                {this.state.productId === 4 ? (
                  <table width="100%">
                    <tbody>
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td style={{ textAlign: 'left' }}>
                          <b>Total</b>
                          <br></br>
                        </td>
                        {this.state.clientId === null && (
                          <>
                            <td style={{ textAlign: 'left' }}>
                              {parseFloat(
                                this.state.monthlyTotalPayment,
                              ).toFixed(2)}
                            </td>
                          </>
                        )}
                        {this.state.clientId !== null && (
                          <>
                            <td style={{ textAlign: 'left' }}>
                              {parseFloat(
                                this.state.monthlyTotalPayment,
                              ).toFixed(2)}
                            </td>
                          </>
                        )}

                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>

                        <td style={{ textAlign: 'left' }}>
                          <b>Stamp Duty</b>
                        </td>
                        <td style={{ textAlign: 'left' }}>
                          {parseFloat(
                            (this.state.monthlyTotalPayment / 100) *
                            this.state.stampDuty,
                          ).toFixed(2)}
                        </td>

                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td style={{ textAlign: 'left' }}>
                          <b>Grand Total</b>
                        </td>
                        {this.state.clientId === null && (
                          <>
                            <td style={{ textAlign: 'left' }}>
                              {parseFloat(
                                (this.state.monthlyTotalPayment / 100) *
                                this.state.stampDuty +
                                this.state.monthlyTotalPayment,
                              ).toFixed(2)}
                            </td>
                          </>
                        )}
                        {this.state.clientId !== null && (
                          <>
                            <td style={{ textAlign: 'left' }}>
                              {parseFloat(
                                (this.state.monthlyTotalPayment / 100) *
                                this.state.stampDuty +
                                this.state.monthlyTotalPayment,
                              ).toFixed(2)}
                            </td>
                          </>
                        )}

                        <td></td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                ) : (
                  ''
                )}
              </div>
            </div>
            <div className="btn-group-success">
              <Button
                className="btn-success"
                size="default"
                value={'submit'}
                onClick={this.submitpolicy}>
                Submit
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const WrappedEditClientQuotation = Form.create({ name: 'Homeinsurance_list' })(
  EditClientQuotation,
)

export default WrappedEditClientQuotation
